export default function getResource(label, vars = []) {
    const resources = {
        title: 'De la foire aux récompenses Rewards Bazaar',
        viewAll: 'Tout afficher',
        add: 'Ajouter'
    };
    return resources[label];
}
